// extracted by mini-css-extract-plugin
export default {"page_title_span":"page_title_page_title_span__Uc1-8","page_title_holder":"page_title_page_title_holder__949j7"};